import { has } from 'lodash';

import type { CumulativeExtendedServiceItem, CumulativeServiceItem, ServiceItem } from 'constants/_types/SelectedServices';

export const resolveIsServiceItemExtended = (serviceItem: ServiceItem | CumulativeServiceItem | CumulativeExtendedServiceItem) =>
  has(serviceItem, 'orderReferral') && has(serviceItem, 'file') && has(serviceItem, 'attachmentId');
